import React, { useEffect, useState } from 'react';
import { WorkData } from './workData';
import "./works.css";
import { Link } from 'react-router-dom';
import logo2 from '../fullpage/logo/images/logo2.png'
import RingLoader from "react-spinners/RingLoader";
import ItemInfo from './itemInfo';
import { MdClose } from "react-icons/md";



Works.propTypes = {
};



function Works(props) {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 3000);
    }, [])


    const [gameList, setGameList] = useState(WorkData);


    const [isActive, setIsActive] = useState(0)

    const checkActiveTab = (index) => {
        setIsActive(index)
    }

    function handleChangeTab(e) {
        if (e.target.innerText === "ALL") {
            console.log(e.target.innerText);
            const filterGame = WorkData.map(item => item)
            setGameList(filterGame)
            return;
        }

        const filterGame = WorkData.filter(game => game.tag === e.target.innerText)
        setGameList(filterGame)
    }

    const [itemClicked, setItemClicked] = useState(-1)
    const test = (index) => {
        setItemClicked(index)
        console.log(itemClicked);
    }

    return (
        <div className="Works">
            {
                isLoading ?
                    <div className="loading" >
                        <RingLoader color={'#34CEE6'} loading={isLoading} size={150} />
                    </div>
                    :
                    <div className="container">
                        <div className="worksTitle">
                            <p>Works</p>
                        </div>
                        <div className="coverList">
                            <div className="coverTag">
                                <ul className="menu">
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(0) }} className={isActive === 0 ? "activeTab" : "inActiveTab"}>All</li>
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(1) }} className={isActive === 1 ? "activeTab" : "inActiveTab"}>Action</li>
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(2) }} className={isActive === 2 ? "activeTab" : "inActiveTab"}>Sport</li>
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(3) }} className={isActive === 3 ? "activeTab" : "inActiveTab"}>Fighting</li>
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(4) }} className={isActive === 4 ? "activeTab" : "inActiveTab"}>Tactic</li>
                                    <li onClick={(e) => { handleChangeTab(e); checkActiveTab(5) }} className={isActive === 5 ? "activeTab" : "inActiveTab"}>Puzzles</li>
                                </ul>
                            </div>
                            <div className="coverGameList">
                                <div className="cover-all-game">
                                    {gameList.map((item, index) => {
                                        return (
                                            <div className="coverGameItem" onClick={() => { test(index) }} key={index} style={{ backgroundImage: `url(${item.imgURL})` }}>
                                                <div className="coverInsideContent">
                                                    <div className="type">{item.tag}</div>
                                                    <div className="gameName">{item.gameName}</div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="linkTab">
                            <Link to="/">
                                <img src={logo2} alt="" width='40px' height='30px' />
                            </Link>
                            <p className="twitter" onClick={() => window.open("https://www.facebook.com/kendi.dang", "_blank")}>twitter</p>
                            <p className="youtube" onClick={() => window.open("https://www.facebook.com/kendi.dang", "_blank")}>youtube</p>
                            <p className="facebook" onClick={() => window.open("https://www.facebook.com/kendi.dang", "_blank")}>facebook</p>
                            <p className="instagram" onClick={() => window.open("https://www.instagram.com/kendi.dang/", "_blank")}>instagram</p>
                        </div>
                    </div>
            }
            {itemClicked !== -1 && <div className={itemClicked === -1 ? "popup-closed" : "popup"}>
                <div className="container">
                    <div className="closeButton" onClick={() => setItemClicked(-1)}>
                        <span ><MdClose></MdClose></span>
                    </div>
                    <div className="coverPopupContent">
                        <ItemInfo itemClickedIndex={itemClicked} itemDatas={gameList}></ItemInfo>
                    </div>
                </div>
            </div>}
        </div>
    );
}

export default Works;